import { Box, Typography } from "@outschool/backpack";
import { CategoryPage } from "@outschool/gql-backend-generated";
import { onlineClassesPath } from "@outschool/routes";
import { getCategoryPillTitle } from "@outschool/text";
import { TopicPill } from "@outschool/ui-components-website";
import { Container, Space } from "@outschool/ui-legacy-component-library";
import { useIsBot } from "@outschool/ui-utils";
import React, { useEffect, useState } from "react";

import { useTopLevelCategoryPagesQuery } from "../../hooks/useTopLevelCategoryPagesQuery";
import Link from "../Link";
import { useTranslateRelatedCategoriesHeading } from "./hooks/useTranslateRelatedCategoriesHeading";

export type PillType = Pick<
  CategoryPage,
  "nameTitleCased" | "slug" | "basePath"
>;

type PillsComponentProps = {
  heading?: CategoryPage;
  categories: CategoryPage[] | PillType[];
  categorySlug: string;
  hasHeading?: boolean;
};

export const PillsComponent = ({
  heading,
  categories,
  categorySlug,
  hasHeading = true
}: PillsComponentProps) => {
  const makeRelatedCategoriesHeading = useTranslateRelatedCategoriesHeading();
  const isBot = useIsBot();
  const [pillsToShow, setPillsToShow] = useState<PillType[]>([]);
  useEffect(() => {
    // show all if you are a bot or they are the topLevelCategoryPages
    const categoriesToShow =
      isBot || heading == null
        ? categories
        : [...categories].sort(() => 0.5 - Math.random()).slice(0, 20);
    setPillsToShow(categoriesToShow);
  }, [categories, isBot, heading]);

  return (
    <Box>
      <Box>
        {!!hasHeading && (
          <Typography emphasized variant="h4">
            {/* @ts-ignore TS(2345): Argument of type 'CategoryPage | undefined' is not... Remove this comment to see the full error message */}
            {makeRelatedCategoriesHeading(heading)}
          </Typography>
        )}

        <Space y={24} />
        <Box
          flex
          sx={{
            columnGap: "8px",
            rowGap: "12px",
            flexWrap: "wrap",
            "a:hover": {
              textDecoration: "none"
            }
          }}
        >
          {pillsToShow.map((category, index) => (
            <Link
              key={category.slug}
              to={onlineClassesPath(category.slug, category?.basePath)}
              trackingName="category_pills"
              trackingUniqueId={category.slug}
              sharedProperties={{ categoryPage: categorySlug, pillIdx: index }}
            >
              <TopicPill>
                {/* @ts-ignore TS(2339): Property 'nameTitleCased' does not exist on type '... Remove this comment to see the full error message */}
                {getCategoryPillTitle(category.nameTitleCased)}
              </TopicPill>
            </Link>
          ))}
        </Box>
      </Box>
      <Space y={30} />
    </Box>
  );
};

const CategoryPills = ({
  category,
  isTutoringCLP
}: {
  category: CategoryPage;
  isTutoringCLP: boolean;
}) => {
  const categorySlug = category.slug;

  const { data } = useTopLevelCategoryPagesQuery();
  const topLevelCategoryPages = data?.topLevelCategoryPages;

  return (
    <Container>
      {/* @ts-ignore TS(2531): Object is possibly 'null'. */}
      {category.related.length + category.children.length > 0 && (
        <PillsComponent
          heading={category}
          // @ts-ignore TS(2488): Type 'Maybe<Maybe<CategoryPage>[]>' must have a '[... Remove this comment to see the full error message
          categories={[...category.children, ...category.related]}
          categorySlug={categorySlug}
        />
      )}
      {/* @ts-ignore TS(2531): Object is possibly 'null'. */}
      {category.parent && category.siblings.length > 0 && (
        <PillsComponent
          heading={category.parent}
          // @ts-ignore TS(2322): Type 'Maybe<Maybe<CategoryPage>[]>' is not assigna... Remove this comment to see the full error message
          categories={category.siblings}
          categorySlug={categorySlug}
        />
      )}
      {/* @ts-ignore TS(2531): Object is possibly 'null'. */}
      {category.grandparent && category.parentalSiblings.length > 0 && (
        <PillsComponent
          heading={category.grandparent}
          // @ts-ignore TS(2322): Type 'Maybe<Maybe<CategoryPage>[]>' is not assigna... Remove this comment to see the full error message
          categories={category.parentalSiblings}
          categorySlug={categorySlug}
        />
      )}
      {!category.grandparent && topLevelCategoryPages && !isTutoringCLP && (
        <PillsComponent
          // @ts-ignore TS(2322): Type 'null' is not assignable to type 'CategoryPag... Remove this comment to see the full error message
          heading={null}
          categories={topLevelCategoryPages}
          categorySlug={categorySlug}
        />
      )}
    </Container>
  );
};

export default CategoryPills;
